var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { getAll as getAllApi } from '../../api/deliveryRequest';
import { useDeliveryRequestColumns } from '../../hooks/useColumns';
import { useRequest } from '../../hooks/requestHook';
import useFetch from '../../hooks/useFetch';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
var WarehouseDeliveryRequestsPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var DeliveryRequestColumns = useDeliveryRequestColumns();
    var getAll = useRequest(getAllApi);
    var urlQuery = qs.parse(location.search.slice(1));
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        if (Object.keys(filters).length === 0 && field === 'status')
            return ['requested'];
        return filters[field];
    }, [urlQuery]);
    var columns = React.useMemo(function () { return [
        __assign(__assign({}, DeliveryRequestColumns.id), { filtering: false, filterCellStyle: {
                minWidth: 0,
            } }),
        __assign(__assign({}, DeliveryRequestColumns.storeName), { filtering: false }),
        __assign(__assign({}, DeliveryRequestColumns.nameWithKana), { filtering: false }),
        __assign(__assign({}, DeliveryRequestColumns.phone), { filtering: false }),
        __assign(__assign({}, DeliveryRequestColumns.postalCode), { filtering: false }),
        __assign(__assign({}, DeliveryRequestColumns.fullAddress), { filtering: false }),
        __assign(__assign({}, DeliveryRequestColumns.deliveryItems), { filtering: false }),
        __assign(__assign({}, DeliveryRequestColumns.status), { defaultFilter: defaultFilter('status') }),
        __assign(__assign({}, DeliveryRequestColumns.createdAt), { filtering: false }),
    ]; }, [defaultFilter, DeliveryRequestColumns]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'status':
                    q.with_status = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (order) {
        switch (order) {
            default:
                return decamelize(order);
        }
    }, []);
    var fetchDeliveryRequests = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
        buildOrder: buildOrder,
    });
    return (React.createElement("div", null,
        React.createElement(MaterialTable, { model: "deliveryRequest", title: t('pages.deliveryRequests.title'), columns: columns, data: fetchDeliveryRequests, options: {
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                },
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
            } })));
};
export default WarehouseDeliveryRequestsPage;
